// path: src/utils/friends.js
// Client-side helpers for Friends Phase B.

import { parseGidInput } from "./gid";

export const FRIEND_REQUEST_STATUS = {
    PENDING: "pending",
    ACCEPTED: "accepted",
    DENIED: "denied",
    CANCELED: "canceled",
};

export function normalizeFriendRequest(id, data = {}) {
    if (!id || !data || typeof data !== "object") {
        return null;
    }

    return {
        id: String(id),
        fromUid: data.fromUid || "",
        toUid: data.toUid || "",
        fromGid: Number(data.fromGid) || null,
        toGid: Number(data.toGid) || null,
        fromUsername:
            typeof data.fromUsername === "string" ? data.fromUsername : "",
        toUsername: typeof data.toUsername === "string" ? data.toUsername : "",
        status: data.status || FRIEND_REQUEST_STATUS.PENDING,
        createdAtMs: data.createdAt?.toMillis
            ? data.createdAt.toMillis()
            : Number(data.createdAtMs) || 0,
        respondedAtMs: data.respondedAt?.toMillis
            ? data.respondedAt.toMillis()
            : Number(data.respondedAtMs) || 0,
    };
}

export function normalizeFriendEdge(id, data = {}) {
    if (!id || !data || typeof data !== "object") {
        return null;
    }

    return {
        uid: String(data.uid || id),
        gid: Number(data.gid) || null,
        username: typeof data.username === "string" ? data.username : "",
        profileImageId:
            data.profileImageId !== null && data.profileImageId !== undefined
                ? data.profileImageId
                : null,
        sinceMs: data.since?.toMillis
            ? data.since.toMillis()
            : Number(data.sinceMs) || 0,
    };
}

export function validateGidInput(raw) {
    const gid = parseGidInput(raw);
    if (!gid) {
        return {
            ok: false,
            gid: null,
            error: "Enter a valid 8-digit GID (no leading zeros).",
        };
    }

    return { ok: true, gid, error: "" };
}
